<template>
  <div class="_accountusers __wrapper_">
    <div class="row h-100">
      <div class="_accountusers__container">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" style="width:200px;">Username</th>
              <th scope="col">Gender</th>
              <th scope="col" style="width: 200px;">Full Name</th>
              <th scope="col">User's Position</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody v-if="users">
            <tr v-for="item in users" :key="item.id">
              <th scope="row"> {{item.username}} </th>
              <td> {{getGender(item.gender)}} </td>
              <td> {{item.fullname}} </td>
              <td>
                <div class="_customdropdown__input">
                  <b-input-group>
                    <b-dropdown right>
                      <template slot="button-content">
                        <p>{{ getUserPosition(item.codeusertype) }}</p>
                      </template>
                      <b-dropdown-item v-on:click="selectedOption(option.text)" v-for="option in optionPosition" :key="option.id">
                        <span>{{ option.text }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                    <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
                  </b-input-group>
                </div>
              </td>
              <td class="text-center"> {{getStatus(item.statverif)}} </td>
            </tr>
          </tbody>
        </table>
        <div class="m-0">
          <button  3  type="button" class="text-center _global__button--corporite">Invite New User</button>
          <button type="button" :disabled="profile.status !== 'ANDALINVERIFICATION'"  class="text-center _global__button--corporite ml-3">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
export default {
  name: '',
  data () {
    return {
      positionValue: [],
      optionPosition: [
        { id: 1, text: 'Admin', value: 'USRA' },
        { id: 2, text: 'Staff', value: 'USRS' }
      ]
    }
  },
  methods: {
    invite: function () {
      this.$eventHub.$emit('dialog-setting-invite', {compName: this.company.name})
    },
    selectedOption: function (event) {
      this.positionValue = event
    },
    fetchUsers () {
      this.$store.dispatch('settingUsers/FETCH_USERS')
    },
    getGender (type) {
      if (type === 'F') { return 'Female' } else if (type === 'M') { return 'Male' } else { return '-' }
    },
    getStatus (type) {
      if (type === 1) { return 'Active' } else { return 'Not Active' }
    },
    getUserPosition (type) {
      if (type === 'USRA') { return 'Admin' } else if (type === 'USRS') { return 'Staff' } else { return 'Select' }
    },
    fetchCompanyProfile () {
      this.$store.dispatch('settingCompany/FETCH_COMPANY')
    }
  },
  created () {
    setTimeout(() => {
      this.positionValue = this.users
    }, 1000)
  },
  computed: {
    ...mapGetters({
      profile: 'auth/profile',
      users: 'settingUsers/users',
      error: 'settingUsers/error',
      isLoading: 'settingUsers/isLoading',
      company: 'settingCompany/company',
      companyError: 'settingCompany/error',
      companyIsLoading: 'settingCompany/isLoading'
    })
  },
  mounted () {
    this.fetchUsers()
    this.fetchCompanyProfile()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/AccountUsers.vue